<app-website-header>
</app-website-header>

<!-- Header area -->

<div class="container-fluid" style="background: #ff761f6b;">

    <div class="container" id="header">

        <div class="row">
            <div class="col-md-6 home-title">
                <h1 class="heading">Tax <span class="highlight-text">Time</span> <span style="color: #000;">?</span></h1>
                <h1 class="heading">Evolv Tax</h1>
                <br>

                <a href="what-are-we">
                    <button class="btn btn-sm about-btn">
                                About Us 
                                </button>
                </a> &nbsp;
                <a href="#bottom">
                    <button class="btn btn-sm contact-btn">Contact Us</button>
                </a>

            </div>

            <div class="col-md-6 header-img" style="z-index: 10;">
                <img src="assets/section-images/Group 82.png" style="z-index: -10" class="img-fluid" alt="" />
            </div>
        </div>


    </div>


</div>


<!-- About Us -->

<div class="container">
    <div class="row header-space ">
        <div class="col-md-6">
            <h2 class="title">ABOUT EVOLVTAX </h2>
            <br>
            <p>
                Evolv Tax is a team of dedicated and experienced professionals committed to delivering quality service to our esteemed clients. Our professional team has successfully assisted our clients in realizing the outsourcing benefit and delivering sustainable
                competitive advantage a head. Evolv Tax offers a wide range of tax services including tax planning, preparation, filing, ITIN Processing Guidance and Renewing ITIN Assistance, FBAR & FATCA Reporting To IRS, Form W4 GUIDANCE and other tax
                advisory services to both US & India Expats and Inpats...</p>
            <br>
            <a href="what-are-we">
                <button class="btn btn-sm about-btn">
                                Read More
                                </button>
            </a>
        </div>

        <div class="col-md-6">
            <img src="assets/section-images/Group 84.png" class="img-fluid" alt="" />

        </div>

    </div>
</div>


<!-- Services -->


<div class="container">
    <div class="row service-space">
        <div class="col-md-12">
            <h1 class="title">WE OFFER SERVICES THAT WORK </h1>
        </div>
    </div>
</div>

<!-- Cards -->

<div class="social-box">
    <div class="container">
        <div class="row">

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1114.png" alt="">
                    <div class="box-title">
                        <h3>FEDERAL & STATE FILING </h3>
                    </div>
                    <div class="box-text">
                        <span>Our tax professionals will do everything from entering the data on all the numerous IRS forms after vigilant analysis with the information and documents provided to us by the clients....</span>
                    </div>
                    <div class="box-btn">
                        <a href="federal">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-xs-12  text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1334.png" alt="">
                    <div class="box-title">
                        <h3>ITIN PREPARATION</h3>
                    </div>
                    <div class="box-text">
                        <span>An Individual Taxpayer Identification Number (ITIN) is a tax processing number issued by the Internal Revenue Service (IRS). The IRS issues ITINs to help individuals comply with the U.S. tax laws....</span>
                    </div>
                    <div class="box-btn">
                        <a href="itIn">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1131.png" alt="">
                    <div class="box-title">
                        <h3>TAX REPRESENTATION </h3>
                    </div>
                    <div class="box-text">
                        <span>230 The IRS has three years from the due date of the tax return to assess any additional taxes that may be owed by issuing an Audit Letter. The IRS has the authority to examine the taxpayer’s books....</span>
                    </div>
                    <div class="box-btn">
                        <a href="tax">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1132.png" alt="">
                    <div class="box-title">
                        <h3>FBAR & FATCA COMPLIANCE </h3>
                    </div>
                    <div class="box-text">
                        <span>All Citizens and Resident Aliens of US are required to file a statement regarding “Report of Foreign Bank and Financial Accounts (FBAR) Form TD F 90-22.1 with IRS, required under Bank Secrecy Act regulations issued by the....</span>
                    </div>
                    <div class="box-btn">
                        <a href="fbar">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1133.png" alt="">
                    <div class="box-title">
                        <h3>ADVANCED TAX PLANNING</h3>
                    </div>
                    <div class="box-text">
                        <span>The goal of tax planning is to arrange your financial affairs so as to minimize your tax liability and maximize tax benefits. You can reduce your income, increase your deductions, and take advantage of tax credit....</span>
                    </div>
                    <div class="box-btn">
                        <a href="advanced">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1360.png" alt="">
                    <div class="box-title">
                        <h3>AMENDMENT FILING</h3>
                    </div>
                    <div class="box-text">
                        <span>An amended tax return generally allows you to file your tax return again to correct your filing status, add or correct your income, claim or allow deductions or credits which you have missed out in....</span>
                    </div>
                    <div class="box-btn">
                        <a href="amendment">Read More</a>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-2">

            </div>

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1135.png" alt="">
                    <div class="box-title">
                        <h3>TAX EVALUATION</h3>
                    </div>
                    <div class="box-text">
                        <span>File your individual Income tax return (Form 1040, 1040A, or 1040EZ) and pay any tax due before April 15th to avoid penalties and Interests....</span>
                    </div>
                    <div class="box-btn">
                        <a href="evaluation">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-xs-12 text-center">
                <div class="box">
                    <img src="assets/section-images/Group 1136.png" alt="">
                    <div class="box-title">
                        <h3>EXTENSION FILING</h3>
                    </div>
                    <div class="box-text">
                        <span>You can also get an extension by paying all or part of your estimated income tax due and indicate that the payment is for an extension using Direct Pay, the Electronic Federal Tax Payment System....</span>
                    </div>
                    <div class="box-btn">
                        <a href="filing">Read More</a>
                    </div>
                </div>
            </div>

            <div class="col-md-2">

            </div>
        </div>
    </div>
</div>


<!-- Need Help -->

<div class="container">
    <div class="row header-space">
        <div class="col-md-5">
            <h2 class="title">NEED HELP?</h2>
            <br>
            <p class="help-subhead">Contact our customer support team if you have any further questions. We are here to help you out.</p>
            <br>
            <a href="tel:+1(737)637-6407">
                <button class="btn btn-sm help-btn">
                    +1 (737) 637 - 6407
                                </button>
            </a>
        </div>

        <div class="col-md-1"></div>

        <div class="col-md-6">
            <img src="assets/section-images/Group 1364.png" class="img-fluid" alt="" />

        </div>

    </div>
</div>


<app-website-footer></app-website-footer>